import { useCreatePlaylistModalPath } from '../savedItemsHooks';
import { RouterLink } from '../../../components/AcademyLinks';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const CreatePlaylistLink = ({
  item,
  children = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.savedItems.createPlaylist"
  }),
  render = (content, to) => /*#__PURE__*/_jsx(RouterLink, {
    to: to,
    children: content
  })
}) => {
  const createPlaylistPath = useCreatePlaylistModalPath(item);
  return render(children, createPlaylistPath);
};
export default CreatePlaylistLink;